module.exports = __webpack_public_path__ + "media/images/icons/v2/briefcase-02-11649e5a21632654f514bfcb98598909.svg";